import { useContext } from "react";
import CheckboxContext from "./CheckboxContext";

function Checkbox({ children, value }) {
  const { isChecked, toggleValue } = useContext(CheckboxContext);

  return (
    <label>
      <input
        type="checkbox"
        checked={isChecked(value)}
        onChange={({ target: { checked } }) => toggleValue({ checked, value })}
      />
      <span>{children}</span>
    </label>
  );
}

export default Checkbox;
